export const wordCharacterCount = (input) => {
  let text = typeof input === "string" ? input : (input == null ? "" : String(input));
  let wordCount = text !== "" ? (text.match(/(\w+)/g)?text.match(/(\w+)/g).length:0) : 0;
  let charCount = text !== "" ? text.length : 0;
  let response = {
    value: input,
    wordCount,
    charCount,
  };
  return response;
};
